import React, { useEffect, useState } from "react";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory } from "../redux/Slices/CategorySlice";

const Search = ({
  categoryInput,
  setCategoryInput,
  selectedDate,
  setSelectedDate,
  handleDateSearch,
  handleCategorySearch,
  tasks,
}) => {
  const [cleared, setCleared] = React.useState(false);
  const [filteredTasks, setFilteredTasks] = useState(tasks);
  const [noMatchMessage, setNoMatchMessage] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const dispatch = useDispatch();

  const { categories } = useSelector((state) => state.categoriesReducer);

  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
        setSelectedDate(null);
      }, 10);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [cleared]);

  useEffect(() => {
    dispatch(fetchCategory());
  }, []);
  const toggleFilter = () => {
    setOpenFilter((prev) => !prev);
  };

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setCategoryInput(value);
    handleCategorySearch(value);
    setSelectedDate(null);
    const matchedTasks = tasks.filter((task) => task.categories === value);
    setFilteredTasks(matchedTasks);
    if (matchedTasks.length === 0) {
      setNoMatchMessage("No tasks match the selected category.");
    } else {
      setNoMatchMessage("");
    }
  };

  const handleChange = (newDate) => {
    console.log(newDate);
    const formattedDate = dayjs(newDate);

    console.log("Selected Date:", formattedDate.format("YYYY-MM-DD"));

    setSelectedDate(formattedDate);

    handleDateSearch(formattedDate);

    setCategoryInput("");

    const matchedTasks = tasks.filter((task) => {
      console.log(task);
      const taskDate = dayjs(task.duedate);
      console.log(taskDate);
      console.log("Task Due Date:", taskDate.format("YYYY-MM-DD"));
      return taskDate.isSame(formattedDate, "day");
    });

    setFilteredTasks(matchedTasks);
    console.log("Matched Tasks:", matchedTasks);

    if (matchedTasks.length === 0) {
      setNoMatchMessage("No tasks match the selected date.");
    } else {
      setNoMatchMessage("");
    }
  };

  return (
    <>
      <div className="d-flex justify-between align-items-center">
        <div className="text-primary fw-bold pl-7 d-flex gap-3 ">
          All Task ({tasks.length})
          <span className="text-danger">
            {filteredTasks.length === 0 && openFilter ? noMatchMessage : null}
          </span>
        </div>
        <button className="btn btn-outline-primary" onClick={toggleFilter}>
          {openFilter ? (
            <i className="bi bi-x-lg"></i>
          ) : (
            <i className="bi bi-filter"></i>
          )}
        </button>
      </div>

      <div className="d-flex justify-end align-items-center gap-1">
        {openFilter ? (
          <>
            {/* Category Filter */}
            <div>
              <FormControl sx={{ minWidth: 150, textAlign: "center", pl: 1 }}>
                <Select
                  value={categoryInput}
                  onChange={handleCategoryChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Select category" }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {categories.map((category) => (
                    <MenuItem key={category.id} value={category.name}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Date Filter */}
            <div className="d-flex">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    label="Date"
                    value={selectedDate}
                    onChange={handleChange}
                    format="DD/MM/YYYY"
                    clearable
                    slotProps={{
                      field: {
                        clearable: true,
                        onClear: () => setCleared(true),
                      },
                    }}
                  />
                </Box>
              </LocalizationProvider>
            </div>
          </>
        ) : (
          <div className="hidden h-16">
            <input></input>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;
